<template>
  <div>
    <div class="product-body com-bg">
      <app-header />
      <!-- banner -->
        <div class="product-banner">
        <div class="Tpictxt">
        </div>
      </div>
      <!-- main -->
      <section class="container-wrap3" style="display:none;">
        <div class="container cont3 textC">
          <p class="intro-tit">认知智能是智能化的关键</p>
          <ul class="list overflow">
            <li class="col col1"><a href="javascript:void(0);" class="icon icon1"></a>
              <p>认知计算和认知诊断能力</p>
              <div>
                理解自然语言，能够像人类一样将<br />信息碎片连接起来进行推理和分析<br />最终获取深度的决策依据和认知诊断能力
              </div>
            </li>
            <li class="col col2"><a href="javascript:void(0);" class="icon icon2"></a>
              <p>机器学习</p>
              <div>
                利用机器学习在不断的交互反馈中优化学习<br />和计算模型，不断成长，以获取新的知识，<br />并改善性能
              </div>
            </li>
            <li class="col col3"><a href="javascript:void(0);" class="icon icon3"></a>
              <p>极致可视化呈现</p>
              <div>
                仪表盘、动态炫丽大屏、报表，数据报告等多<br />呈现形态，PC显示器、移动端、投影仪等多<br />终端支持，完备的权限控制
              </div>
            </li>
          </ul>
        </div>
      </section>

      <div class="newxinjia11_27">
        <div class="zouzhe11_27">
          <div class="zouzheli11_27">
            <div class="tech_midicon">
              <div class="tech_midicobg"></div>
              <img src="../assets/images/tech_midico_gz.png" class="img">
            </div>
            <div class="tl">感知</div>
            <div class="tlps">图像、语音、文字等多模态数据采集与感知技术</div>
          </div>
          <div class="zouzheli11_27">
            <div class="tech_midicon">
              <div class="tech_midicobg"></div>
              <img src="../assets/images/tech_midico_rz.png" class="img">
            </div>
            <div class="tl">认知</div>
            <div class="tlps">自然语言处理、神经网络、深度学习及边缘计算等认知计算技术</div>
          </div>
          <div class="zouzheli11_27">
            <div class="tech_midicon">
              <div class="tech_midicobg"></div>
              <img src="../assets/images/tech_midico_zd.png" class="img">
            </div>
            <div class="tl">诊断</div>
            <div class="tlps">医学生物特征智能分类识别、匹配、评估、处理、推荐等辅助诊断技术</div>
          </div>
        </div>
      </div>

      <!--  -->
      <div class="content-wrap aipro-bg">
        <div class="cont4-box">
          <div class="aipro-tit">
            <h5>产品系统</h5>
            <p>吾征AI平台为用户提供科学验证的专业解决方案</p>
          </div>
          <div class="aipro-warp">
            <ul class="clear">
              <li>
                <div class="aipro-cont">
                  <div class="atpro-icon">
                    <img src="../assets/images/pro-icon1s.png">
                  </div>
                  <div class="aipro-name">
                    <div>
                      <p>心脑血管监测预警救援系统</p>
                    </div>
                  </div>
                  <a href="javascript:void(0)" ><span @click="tiao()">了解详情</span></a>
                </div>
              </li>
              <li>
                <div class="aipro-cont">
                  <div class="atpro-icon">
                    <img src="../assets/images/pro-icon1.png">
                  </div>
                  <div class="aipro-name">
                    <div>
                      <p>中西医AI辩证分型</p>
                    </div>
                  </div>
                  <a href="http://htcm.wuzhengai.com" target="_blank">了解详情</a>
                </div>
              </li>
              <li>
                <div class="aipro-cont">
                  <div class="atpro-icon">
                    <img src="../assets/images/pro-icon2.png">
                  </div>
                  <div class="aipro-name">
                    <div>
                      <p>化验单智能解读</p>
                    </div>
                  </div>
                  <a href="http://hlab.wuzhengai.com" target="_blank">了解详情</a>
                </div>
              </li>
              <li>
                <div class="aipro-cont">
                  <div class="atpro-icon">
                    <img src="../assets/images/pro-icon3.png">
                  </div>
                  <div class="aipro-name">
                    <div>
                      <p>AI影像筛查系统</p>
                    </div>
                  </div>
                  <a href="http://himage.wuzhengai.com" target="_balnk">了解详情</a>
                </div>
              </li>
              <li>
                <div class="aipro-cont">
                  <div class="atpro-icon">
                    <img src="../assets/images/pro-icon4.png">
                  </div>
                  <div class="aipro-name">
                    <div>
                      <p>AI环境与疾病预警终端与系统</p>
                    </div>
                  </div>
                  <a href="http://henv.wuzhengai.com" target="_blank">了解详情</a>
                </div>
              </li>
              <li>
                <div class="aipro-cont">
                  <div class="atpro-icon">
                    <img src="../assets/images/pro-icon5.png">
                  </div>
                  <div class="aipro-name">
                    <div>
                      <p>数字健康孪生人</p>
                    </div>
                  </div>
                  <a href="http://hdigit.wuzhengai.com" target="_blank">了解详情</a>
                </div>
              </li>
              <li>
                <div class="aipro-cont">
                  <div class="atpro-icon">
                    <img src="../assets/images/pro-icon6.png">
                  </div>
                  <div class="aipro-name">
                    <div>
                      <p>饮食行为预警预测</p>
                    </div>
                  </div>
                  <a href="http://hdiet.wuzhengai.com" target="_blank">了解详情</a>
                </div>
              </li>
              <li>
                <div class="aipro-cont">
                  <div class="atpro-icon">
                    <img src="../assets/images/pro-icon7.png">
                  </div>
                  <div class="aipro-name">
                    <div>
                      <p>人体异常信号认知</p>
                    </div>
                  </div>
                  <a href="http://hsign.wuzhengai.com" target="_blank">了解详情</a>
                </div>
              </li>
              <li>
                <div class="aipro-cont">
                  <div class="atpro-icon">
                    <img src="../assets/images/pro-icon8.png">
                  </div>
                  <div class="aipro-name">
                    <div>
                      <p>人体医学生物特征疾病知识图谱</p>
                    </div>
                  </div>
                  <a href="http://klg.wuzhengai.com/index" target="_blank">了解详情</a>
                </div>
              </li>
              <li>
                <div class="aipro-cont">
                  <div class="atpro-icon">
                    <img src="../assets/images/pro-icon9.svg">
                  </div>
                  <div class="aipro-name">
                    <div>
                      <p>风险算法与模型</p>
                    </div>
                  </div>
                  <a href="http://hgrs.wuzhengai.com" target="_blank">了解详情</a>
                </div>
              </li>

            </ul>
          </div>
        </div>
      </div>

      <!-- 技术介绍 -->
      <div class="container tech-js">
        <div class="cont4-box">
          <h5>技术介绍</h5>
          <div class="tech-js-list">
            <ul class="clear">
              <li>
                <i class="tech-js-icon"><img src="../assets/images/seicon-1.png"></i>
                <div class="tech-js-txt">
                  <h3>图像识别技术</h3>
                  <p>从大量信息和数据出发，利用计算机和数学推理的方法，对图形自动完成识别、评价。</p>
                </div>
              </li>
              <li>
                <i class="tech-js-icon"><img src="../assets/images/seicon-2.png"></i>
                <div class="tech-js-txt">
                  <h3>云计算技术</h3>
                  <p>可以在数秒之内，达成处理数以千万计甚至亿计的信息，达到和“超级计算机”同样强大效能的网络服务。</p>
                </div>
              </li>
              <li>
                <i class="tech-js-icon"><img src="../assets/images/seicon-3.png"></i>
                <div class="tech-js-txt">
                  <h3>深度学习技术</h3>
                  <p>通过建立、模拟人脑进行分析学习，模仿人脑的机制来解释图像。</p>
                </div>
              </li>
              <li>
                <i class="tech-js-icon"><img src="../assets/images/seicon-4.png"></i>
                <div class="tech-js-txt">
                  <h3>语义认知技术</h3>
                  <p>通过模拟人类思维方式去思考、推理问题，完成“人工智能”这个人类伟大理想。</p>
                </div>
              </li>
            </ul>
          </div>
          <div class="tech-js-cont">
            <ul class="clear">
              <li>
                <div class="tech-js-b">
                  <div class="tech-js-img"><img src="../assets/images/browser-icon.png"></div>
                  <h3>支持主流浏览器</h3>
                  <p>吾征AI开放平台兼容目前各种主流浏览器，包括IE(微软浏览器)、Chrome(谷歌浏览器)、Firefox(火狐浏览器)、Safari(苹果浏览器)、Opera，以及国内众多基于IE内核的浏览器，如360、QQ等。</p>
                </div>
              </li>
              <li>
                <div class="tech-js-b">
                  <div class="tech-js-img"><img src="../assets/images/api-icon.png"></div>
                  <h3>主流接口随意调用</h3>
                  <p>吾征AI开放平台集成了API\SDK等接口，开发者无需研究啰嗦的接口规则，直接在自己开发的应用中使用。持续跟进热门接口。也可以依据需求，定制测试算法及软件功能。</p>
                </div>
              </li>
              <li>
                <div class="tech-js-b">
                  <div class="tech-js-img"><img src="../assets/images/sdev-icon.png"></div>
                  <h3>多种硬件轻松接入</h3>
                  <p>通过吾征AI开发平台内置接口可轻松接入各类硬件，无需研究其复杂难懂的原始接口。如智能穿戴设备、移动医疗设备、智能家居、智能手机等各类设备与终端等。</p>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <!-- 技术能力 -->
      <div class="container tech-nl">
        <div class="cont4-box">
          <div class="tech-nl-tie">
            <h5>技术能力</h5>
            <p>将客观存在看作实体（也有人称为实例、对象、场景等），将实体的属性（如颜色、形状等）通过分词（意群或叫短文本）形式识别出来，将实体之间的联系用某种形式（矩阵+符号系统）表达出来，是一种尽可能贴近现实世界的思维方式。</p>
          </div>
          <div class="tech-nl-list">
            <ul class="clear">
              <li>
                <div class="tech-nl-c">
                  <i class="ic-1"></i>
                  <div class="tech-nl-txt">
                    <h3>智能</h3>
                    <p>基于语言和语义计算技术，让机器高效掌握大量专业知识，拥有强大的人机交互和推理决策能力，灵活应对各种复杂业务类型，并在服务过程中不断自我优化，提升智能水平。</p>
                  </div>
                </div>
              </li>
              <li>
                <div class="tech-nl-c">
                  <i class="ic-2"></i>
                  <div class="tech-nl-txt">
                    <h3>快速</h3>
                    <p>基于端到端的方法、工具及模型，能够快速构建不同场景、各个领域的专业应用，轻松打造专家级智能服务系统，真正实现AI+的行业领域解决方案。</p>
                  </div>
                </div>
              </li>
              <li>
                <div class="tech-nl-c">
                  <i class="ic-3"></i>
                  <div class="tech-nl-txt">
                    <h3>可管理</h3>
                    <p>基于多层次的知识管理和语言计算工具，让用户轻松高效管理各类知识及应用；做到过程可追溯，输出结果可控制，实现“可解释的人工智能”。</p>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <section class="container cont4">
        <div class="cont4-box">
          <p class="intro-tit textC">核心技术：医学生物特征中文矩阵式认知计算</p>
          <div class="box box1 overflow">
            <div class="icon left"></div>
            <div class="cont6_4 left" style="box-sizing: border-box;">
              <div class="icon-tit">融合认知计算的疾病知识跟踪方法</div>
              <p>通过统计的疾病知识组件样本数据建立认知者的记忆系统M、学习系统L和表现状态O，并进行迭代计算待测疾病知识组件的后验概率P(M,L|O)，利用后验概率计算认知模型的参数值，进而利用认知模型推导出认知者对待测疾病知识组件的认知表现数据。</p>
            </div>
          </div>
          <div style="clear: both;"></div>

          <div class="box box2 overflow">
            <div class="cont6_4 left">
              <div class="icon-tit">概念间关系的语义相关度计算方法</div>
              <p>在基本相似度计算方法的基础 上，结合两个概念之间共同具有关系计算出来的语义度以及两个概念之间独自具有的关系计算出来的语义度，得到最终的语义相关度计算值。该方法充分考虑了 两个概念之间的关系，具有相同属性以及各自具有的独特属性，均在计算中得以体现，更接近人的判定结果，计算结果更准确。</p>
            </div>
            <div class="icon left"></div>
          </div>
          <div style="clear: both;"></div>

          <div class="box box3 overflow">
            <div class="icon left"></div>
            <div class="cont6_4 left" style="box-sizing: border-box;">
              <div class="icon-tit">词袋模型的文本表示的处理方法</div>
              <p>对采集到的文本数据集进行分词，去停顿词，去低频词，特征选择等处理过程；然后运用空间向量模 型表示处理后的文本；同时对处理后的文本运用 神经网络的方法训练词向量；根据词向量的相似性修改词袋模型的特征词的权重，得到新的文本表示模型。用以处理文本表示问题，提高了分类的准确性。</p>
            </div>
          </div>
          <div style="clear: both;"></div>

          <div class="box box4 overflow">
            <div class="cont6_4 left" style="box-sizing: border-box;">
              <div class="icon-tit">多个对象属性匹配与计算方法</div>
              <p>获取多个对象中各个对象的属性；对多个对象及属性进行整合，建立对象与属性的对应关系；其中，每个属性对应至少一个对象；基于对应关系确定所述多个对象中各个对象相互之间的相似度；根据相似度确定所述多个对象中各个对象相互之间的匹配关系。本系统是对对象的属性进行对象之间相似度的计算，从而确定对象之间的匹配关系。</p>
            </div>
            <div class="icon left"></div>
          </div>
          <div style="clear: both;"></div>

          <div class="box box5 overflow">
            <div class="icon left"></div>
            <div class="cont6_4 left" style="box-sizing: border-box;">
              <div class="icon-tit">采样图像分类处理系统及方法</div>
              <p>首先获取采样图像，从图像中提取相关颜色、纹理等特征信息，再基于深度学习的方式对图像进行分类训练，进而得到分类训练结果，本方法可以大大提高图像分类识别的准确率，大大 的提高了疾病筛查的效率，为疾病的筛查工作起到了较好的辅助作用。</p>
            </div>
          </div>
          <div style="clear: both;"></div>

          <div class="box box6 overflow">
            <div class="cont6_4 left" style="box-sizing: border-box;">
              <div class="icon-tit">特征模型生成方法和系统</div>
              <p>系统从建立特征词典模型的第一步开始，利用目标对象各个部分（即特征点）之间的内在结构关系来建立该目标对象内部的空间关联性，并且基于这种空间关联性来执行各特征点与特征词典模型中各词条之间的特征权重映射，从而能够生成具有空间信息的、基于词条的权重的目标对象的特征模型。</p>
            </div>
            <div class="icon left"></div>
          </div>
          <div style="clear: both;"></div>

          <div class="box box7 overflow">
            <div class="icon left"></div>
            <div class="cont6_4 left" style="box-sizing: border-box;">
              <div class="icon-tit" style="padding-top: 30px;">人脑语言认知建模方法</div>
              <p style="padding-top: 20px;">将认知实验中被观测到的时间系列脑激活数据对应于汉语认知状态实例的反映矩集合，其中每个状态实例在某个时间间隔都依概率起作用，在其作用的时段每 个状态实例影响着数据采集时所观测到的激活特征。如果多个状态实例几乎同时起作用， 那么观测到的激活特征是所有相关状态实例产生的效果叠加，为认知状态细分提供了基 础，进而提高了认知建模的精度，也为复杂认知分析提供了有效途径。这是一种适于小样本、具有动态时间特征的人脑语言认知建模方法。</p>
            </div>
          </div>
          <div style="clear: both;"></div>

          <div class="box box8 overflow">
            <div class="cont6_4 left" style="box-sizing: border-box;">
              <div class="icon-tit">面向矩阵型任务的异构计算系统</div>
              <p>矩阵型异构计算架构由许多不同的计算元素（处理器或内核）组成，具有不同的指令集。这些元素可以包括通用处理器、GPU、NPU、ASIC、FPGA等。这些元素通常被组合成一个SoC（称为系统级芯片）。异构计算允许更高程度的并行计算和执行成速度，非常适合矩阵型计算任务。</p>
            </div>
            <div class="icon left"></div>
          </div>
          <div style="clear: both;"></div>

          <div class="box box9 overflow">
            <div class="icon left"></div>
            <div class="cont6_4 left" style="box-sizing: border-box;">
              <div class="icon-tit">一种特征层动态加权融合匹配算法</div>
              <p style="padding-top: 20px;">在人体医学生物特征图像预处理的基础上，分别提取多模式源的有效特征矢量，根据近邻消除和特殊区域保留原则，对特征矢量进行降维。然后从待识别特征角度对特征点集的相对质量进行评价,根据对多模态特征优和差的分类引入动态加权策略，提高质量较好特征所占权重，削弱低质量及伪特征对识别结果的影响,实现特征层特征自适应优化融合。</p>
            </div>
          </div>
          <div style="clear: both;"></div>

          <div class="box box10 overflow">
            <div class="cont6_4 left" style="box-sizing: border-box;">
              <div class="icon-tit" style="padding-top:30px;">基于在线字典学习的自适应医学图像融合算法</div>
              <p style="padding-top:15px;">首先利用在线字典学习理论训练源图像的过完备字典；然后利用正交匹配追踪算法对源图像进行稀疏分解得到稀疏编码，根据源图像之间稀疏编码的能量差异程度和梯度差异程度自适应调整融合准则，若能量差异程度大于梯度差异程度，则根据能量取大准则融合稀疏编码；反之，根据梯度取大准则融合稀疏编码；最后将融合后的稀疏编码与过完备字典进行重构得到融合图像。</p>
            </div>
            <div class="icon left"></div>
          </div>
          <div style="clear: both;"></div>
        </div>
      </section>
      <!-- 智能认知系统 -->
      <section class="container-ai com-bg">
        <div class="container-aiwarp cont11_17">
          <h4>全品类健康智能认知系统</h4>
          <p class="z-aitxt">只比别人多了些智能认知分析</p>
          <div class="z-ai-warp">
            <div class="z-ai-tab clear">
              <span class="active">人体健康认知与疾病筛查预测系统</span>
              <span>疾病认知辅助诊断系统</span>
              <span>环境认知与疾病预警预测系统</span>
              <span>基于穿衣指数的跨模态疾病风险预测系统</span>
            </div>
            <div class="z-ai-cont">
              <!-- tab1 -->
              <div class="z-ai-list zbga zshow">
                <div class="z-ai-pro">
                  <h3>人体健康认知与疾病筛查预测系统</h3>
                  <p>人体健康认知与疾病筛查预测系统”是从人体体相、征兆、病理、生理、心理等多方位认知角度，通过对人体多维度的症状信息整理分析，对人体健康信息进行全方位的、智能化的认知分析及疾病筛查。</p>
                  <a href="#">查看详情</a>
                </div>
              </div>
              <!-- tab2 -->
              <div class="z-ai-list zbgb">
                <div class="z-ai-pro">
                  <h3>疾病认知辅助诊断系统</h3>
                  <p>通过获取人体包括“血压”、“血糖”、“尿酸”、“血脂”在内的各项监测指标信息，通过类似人类专家思维及知识推理能力的算法模型，对人体进行智能疾病分析及预警。</p>
                  <a href="#">查看详情</a>
                </div>
              </div>
              <!-- tab3 -->
              <div class="z-ai-list zbgc">
                <div class="z-ai-pro">
                  <h3>环境认知与疾病预警预测系统</h3>
                  <p>“环境认知与疾病预警预测系统”包括“室内温湿度与致病病菌预测预警系统”、“发热门诊辅助诊断智能筛查助手”、“行业热成像人体测温初筛系统”在内的一体化行业环境解决方案。</p>
                  <a href="#">查看详情</a>
                </div>
              </div>
              <!-- tab4 -->
              <div class="z-ai-list zbgd">
                <div class="z-ai-pro">
                  <h3>基于穿衣指数的跨模态疾病风险预测系统</h3>
                  <p>通过建立在不同的季节、不同的气候条件下穿衣指数等级、人体舒适度指数级别、穿衣建议与方案以及对应的疾病和健康风险程度建立跨模态疾病风险预测模型和穿衣推荐模型，并利用DNN反向传播算法，得到可能的健康和疾病风险概率以及从所有有效衣物中匹配出至少一种穿衣方案和推荐指数，并用于辅助着装管理和健康管理。</p>
                  <a href="#">查看详情</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <app-footer />
    </div>
  </div>
</template>

<script>
import header from '@/components/header'
import footer from '@/components/footer'
// import Swiper from 'swiper'
// import flickerplate from '../assets/js/flickerplate.min.js'
/*import product from '../assets/js/product.js'*/


var i = 0;
export default {
  data () {
    return {

    }
  },
  components: {
    'app-header': header,
    'app-footer': footer,
  },
  mounted () {
    $('.flicker-example').flicker();
    $(".z-ai-tab span").click(function () {
      $(".z-ai-tab span").eq($(this).index()).addClass("active").siblings().removeClass('active');
      $(".z-ai-list").eq($(".z-ai-tab span").index(this)).addClass("zshow").siblings().removeClass('zshow');
    });
  },
  methods: {
    tiao(){

        this.$router.push('cardiobrain');
        },
    fleash (value) {
      if (value == 1) {
        this.$router.go(0);
        i++;
      }
    }
  },
}
</script>

<style>
@import "../assets/css/tech.css";
.newxinjia11_27 {
  width: 100%;
  height: 500px;
  background-color: #fff;
}
.zouzhe11_27 {
  width: 1200px;
  margin: 0 auto;
}
.zouzheli11_27 {
  width: 400px;
  float: left;
  padding: 0 53px;
  box-sizing: border-box;
}
.zouzheli11_27 .img {
  width: 194px;
  height: 214px;
  float: left;
  margin-left: 50px;
  margin-top: 70px;
}
.zouzheli11_27 .tl {
  width: 100%;
  float: left;
  text-align: center;
  font-size: 26px;
  color: #222;
  margin-top: 30px;
}
.zouzheli11_27 .tlps {
  width: 100%;
  float: left;
  text-align: center;
  font-size: 16px;
  color: #999;
  line-height: 30px;
  margin-top: 10px;
}
.flickerplate {
  background: none !important;
}
.cont11_17 .z-ai-cont {
  height: 300px !important;
}
.cont11_17 .z-ai-list p {
  line-height: 30px !important;
  font-size: 16px !important;
  padding: 20px 200px 0 !important;
  text-indent: 2em !important;
  text-align: left !important;
  color: #fff !important;
}
.cont11_17 .z-ai-pro p {
  line-height: 30px;
  font-size: 16px;
  padding: 20px 300px 0;
  text-indent: 2em;
  text-align: left;
}
.product-body .product-banner {
  margin-top: 0 !important;
}
.Tpictxt {
  width: 1205px;
  height: 160px;
  margin: 0 auto;
  background: url(../assets/images/tech_Picturetext.png) no-repeat center;
  background-size: 100%;
  margin-top: 230px;
  display: none;
}
/* 感知认知诊断css效果 */
@keyframes fa-spin {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(359deg);
    transform: rotate(359deg);
  }
}
@keyframes upDown {
  0% {
    -webkit-transform: translateY(0);
    transform: translateY(0);
  }
  25% {
    -webkit-transform: translateY(-10px);
    transform: translateY(-10px);
  }
  50% {
    -webkit-transform: translateY(0);
    transform: translateY(0);
  }
  75% {
    -webkit-transform: translateY(10px);
    transform: translateY(10px);
  }
  100% {
    -webkit-transform: translateY(0);
    transform: translateY(0);
  }
}
@-webkit-keyframes upDown {
  0% {
    -webkit-transform: translateY(0);
    transform: translateY(0);
  }
  25% {
    -webkit-transform: translateY(-10px);
    transform: translateY(-10px);
  }
  50% {
    -webkit-transform: translateY(0);
    transform: translateY(0);
  }
  75% {
    -webkit-transform: translateY(10px);
    transform: translateY(10px);
  }
  100% {
    -webkit-transform: translateY(0);
    transform: translateY(0);
  }
}

.tech_midicon {
  width: 190px;
  height: 210px;
  margin: 70px 0 0 50px;
  position: relative;
}
.tech_midicon .tech_midicobg {
  width: 190px;
  height: 210px;
  position: absolute;
  left: 0;
  top: 0;
  background: url(../assets/images/tech_midico_bg.png) no-repeat center;
}
.tech_midicon:hover .tech_midicobg {
  -webkit-animation: fa-spin 15s infinite linear;
  animation: fa-spin 15s infinite linear;
}
.tech_midicon .img {
  width: auto;
  height: auto;
  margin: 0;
  position: absolute;
  left: 0;
  top: 0;
  z-index: 2;
}
.tech_midicon:hover .img {
  animation: upDown 2s infinite linear;
  -webkit-animation: upDown 2s infinite linear;
}
</style>



// WEBPACK FOOTER //
// src/components/tech.vue